import { useEffect, useState } from "react";
import useFirestore from "../common/useFirestore";

function useInstructor(){
    const {readFirestore} = useFirestore();
    const [instructorList, setInstructorList] = useState([]);

    useEffect(() => {
        getInstructorList();
    }, [])

    const getInstructorList = async() => {
        const instructor_list = await readFirestore("Instructor").then(res => {
            const list = [];
            if(!res.empty){
                const doc_list = res.docs;
                for(const doc of doc_list){
                    const data = doc.data();
                    list.push({...data, id:doc.id});
                }
            }
            return list;
        })
        setInstructorList(instructor_list);
    }

    return {instructorList};
}

export default useInstructor;